import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { asQuestionAnswerArray, asTextArray } from '../../lib/educationContent';
import LearningList from './LearningList';
import LearningSection from './LearningSection';

const TopicContentSections = ({ topic }) => {
  const commonQuestions = asQuestionAnswerArray(topic.common_questions_json);
  const misconceptions = asTextArray(topic.common_misconceptions_json);
  const mistakes = asTextArray(topic.common_mistakes_json);
  const examples = asTextArray(topic.examples_json);

  return (
    <div className="space-y-6">
      <LearningSection title="Plain English" icon={FiIcons.FiBookOpen}>
        {topic.plain_english_explanation}
      </LearningSection>

      <LearningSection title="Why This Matters" icon={FiIcons.FiInfo}>
        {topic.why_this_matters}
      </LearningSection>

      <LearningSection title="Deeper Explanation" icon={FiIcons.FiFileText}>
        {topic.full_explanation}
      </LearningSection>

      {commonQuestions.length > 0 && (
        <LearningSection title="Common Questions" icon={FiIcons.FiHelpCircle}>
          <div className="space-y-4">
            {commonQuestions.map((item) => (
              <div key={`${item.question}-${item.answer}`} className="rounded-lg bg-slate-50 p-4">
                {item.question && <p className="font-semibold text-slate-900">{item.question}</p>}
                {item.answer && <p className="mt-1 text-slate-600">{item.answer}</p>}
              </div>
            ))}
          </div>
        </LearningSection>
      )}

      <LearningSection title="Common Misconceptions" icon={FiIcons.FiAlertCircle}>
        <LearningList items={misconceptions} prefix="Misconception:" />
      </LearningSection>

      <LearningSection title="Examples" icon={FiIcons.FiCompass}>
        <LearningList items={examples} />
      </LearningSection>

      {mistakes.length > 0 && (
        <LearningSection title="Common Mistakes" icon={FiIcons.FiAlertTriangle}>
          <LearningList items={mistakes} />
        </LearningSection>
      )}
    </div>
  );
};

export default TopicContentSections;
